import React, { useContext, useEffect, useState } from 'react';
import {
  Box, Button, TextField, Typography, Tabs, Tab, Container,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Dialog, DialogTitle, DialogContent, IconButton,
  Tooltip, Autocomplete
} from '@mui/material';
import { AuthContext } from '../..';
import axios from 'axios';
import Swal from 'sweetalert2';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';

export default function PriorityAndCategoryMaster() {
  const { companyid, permissions, token, employeeId, trainersdata } = useContext(AuthContext);
  const [formdata, setFormdata] = useState({ tab: "1", value: "" });
  const [currentType, setCurrentType] = useState("Trainers");
  const [activeTab, setActiveTab] = useState(1);

  const [priorityData, setPriorityData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [editicon, setEditicon] = useState(true);
  const [deleteicon, setDeleteicon] = useState(true);

  // New state for employees list (for Trainers tab autocomplete)
  const [employees, setEmployees] = useState([]);
  const [selectedTrainer, setSelectedTrainer] = useState(null);

  const handleTab = (e, value) => {
    setActiveTab(value);
    if (value === 1) {
      setCurrentType("Trainers");
      setFormdata(prev => ({ ...prev, tab: "1" }));
    } else {
      setCurrentType("Service Category");
      setFormdata(prev => ({ ...prev, tab: "2" }));
    }
  };

  const handler = (e) => {
    const { name, value } = e.target;
    setFormdata({ ...formdata, [name]: value });
  };

  const handleAdd = () => {
    if (formdata.tab === "1") {
      // Trainers tab → send employee ID
      if (!selectedTrainer) {
        Swal.fire({ icon: 'warning', title: 'Please select a trainer', timer: 1500 });
        return;
      }
      const payload = {
        tab: "1",
        value: selectedTrainer.id,   // sending ID instead of name
      };
      axios.post(`${process.env.REACT_APP_API_LINKS}/othersmaster/add`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      })
        .then(res => {
          if (res.status === 200) {
            Swal.fire({ icon: 'success', title: 'Added', text: 'Trainer added successfully', timer: 1500, showConfirmButton: false });
            setSelectedTrainer(null);
            refreshData();
          }
        })
        .catch(err => {
          Swal.fire({ icon: 'error', title: 'Error', text: 'Already Exists or Failed', timer: 1500, showConfirmButton: false });
        });
    } else {
      // Service Category tab → normal string
      if (!formdata.value?.trim()) return;
      axios.post(`${process.env.REACT_APP_API_LINKS}/othersmaster/add`, formdata, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      })
        .then(res => {
          if (res.status === 200) {
            Swal.fire({ icon: 'success', title: 'Added', text: 'Entry added successfully', timer: 1500, showConfirmButton: false });
            setFormdata(prev => ({ ...prev, value: "" }));
            refreshData();
          }
        })
        .catch(err => {
          Swal.fire({ icon: 'error', title: 'Error', text: 'Already Exists or Failed', timer: 1500, showConfirmButton: false });
        });
    }
  };

  const refreshData = () => {
    axios.get(`${process.env.REACT_APP_API_LINKS}/othersmaster/get`, {
      headers: { Authorization: `bearer ${token}` },
      withCredentials: true
    })
      .then(res => {
        setPriorityData(res.data.trainers || []);
        setCategoryData(res.data.serviceCategory || []);
      })
      .catch(err => {
        console.error('Error fetching data:', err);
      });
  };

  // Fetch employees list for Trainers tab
  const fetchEmployees = () => {
    axios.get(`${process.env.REACT_APP_API_LINKS}/employees/getemployees`, {
      headers: { Authorization: `bearer ${token}` },
      withCredentials: true
    })
      .then(res => {
        setEmployees(res.data.data || []);
      })
      .catch(err => {
        console.error('Error fetching employees:', err);
      });
  };

  const getCurrentData = () => {
    return formdata.tab === "1" ? priorityData : categoryData;
  };

  const handleEditClick = (id, value) => {
    setEditId(id);
    setEditValue(value);
    setEditDialogOpen(true);
  };

  const handleUpdate = async () => {
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_LINKS}/othersmaster/update/${editId}`, {
        value: editValue,
        tab: formdata.tab,
      },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
      if (res.status === 200) {
        Swal.fire({ icon: 'success', title: 'Updated', timer: 1500, showConfirmButton: false });
        setEditDialogOpen(false);
        refreshData();
      }
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Update failed', timer: 1500, showConfirmButton: false });
    }
  };

  const handleDelete = (id) => {
    axios.delete(`${process.env.REACT_APP_API_LINKS}/othersmaster/delete/${id}/${formdata.tab}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    )
      .then(res => {
        if (res.status === 200) {
          Swal.fire({ icon: 'success', title: 'Deleted', text: 'Entry deleted', timer: 1500, showConfirmButton: false });
          refreshData();
        }
      })
      .catch(err => {
        Swal.fire({ icon: 'error', title: 'Failed', text: 'Could not delete the item', timer: 1500, showConfirmButton: false });
      });
  };

  useEffect(() => {
    refreshData();
    fetchEmployees(); // Load employees once on mount
  }, []);

  const permissionsaccess = () => {
    const mastersmodule = permissions.masters || {};
    setDeleteicon(mastersmodule.delete === true);
    // We will control edit icon per tab in render, not globally
    setEditicon(mastersmodule.update === true);
  };

  useEffect(() => {
    if (permissions && permissions.masters) {
      permissionsaccess();
    }
  }, [permissions]);

  const currentData = getCurrentData();

  return (
    <Container maxWidth={false} disableGutters sx={{
      px: { xs: 2, sm: 3 },
      py: 3,
      backgroundColor: '#fff',
      minHeight: 'calc(100vh - 64px)',
      borderRadius: 2,
      boxShadow: { xs: 'none', sm: '0 0 8px rgba(0,0,0,0.1)' }
    }}>
      <Box fontFamily="Open Sans">
        <Tabs value={activeTab} onChange={handleTab} indicatorColor="primary" textColor="primary" variant="scrollable">
          <Tab label="Trainers" value={1} sx={{ fontSize: { xs: 12, sm: 14 } }} />
          <Tab label="Service Category" value={2} sx={{ fontSize: { xs: 12, sm: 14 } }} />
        </Tabs>

        <Typography variant="h6" fontWeight={600} textAlign="center" my={2}>
          {currentType}
        </Typography>

        {permissions?.masters?.create && (
          <Box display="flex" gap={2} mb={2} alignItems="center">
            {activeTab === 1 ? (
              // Trainers tab → Autocomplete with employee list
              <Autocomplete
                options={employees}
                getOptionLabel={(option) => option.employee_name || ''}
                value={selectedTrainer}
                onChange={(e, newValue) => setSelectedTrainer(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Trainer"
                    size="small"
                    fullWidth
                    placeholder="Search trainer..."
                  />
                )}
                sx={{ flex: 1 }}
              />
            ) : (
              // Service Category → normal text input
              <TextField
                name="value"
                fullWidth
                size="small"
                placeholder={`Add new ${currentType}`}
                value={formdata.value}
                onChange={handler}
              />
            )}

            <Button variant="contained" sx={{ bgcolor: '#0b85c8' }} onClick={handleAdd}>
              Add
            </Button>
          </Box>
        )}

        {currentData.length > 0 && (
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: { xs: 300, sm: 400, md: 'calc(100vh - 220px)' },
              overflow: 'auto'
            }}
          >
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>{currentType}</TableCell>
                  {(editicon || deleteicon) && <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>Actions</TableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {currentData.map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell sx={{ textTransform: 'capitalize' }}>
                      {activeTab === 1 ? item.employee_name || item.value : item.value}
                    </TableCell>
                    {(editicon || deleteicon) && (
                      <TableCell>
                        {/* Show Edit only for Service Category (tab 2) */}
                        {activeTab === 2 && editicon && (
                          <Tooltip title="Edit">
                            <IconButton onClick={() => handleEditClick(item.id, item.value)}>
                              <EditIcon sx={{ fontSize: 18, color: '#0b85c8' }} />
                            </IconButton>
                          </Tooltip>
                        )}

                        {activeTab === 1 && deleteicon && (
                          <Tooltip title="Delete">
                            <IconButton onClick={() => handleDelete(item.demoid)}>
                              <DeleteIcon sx={{ fontSize: 18, color: 'red' }} />
                            </IconButton>
                          </Tooltip>
                        )}
                        {activeTab === 2 && deleteicon && (
                          <Tooltip title="Delete">
                            <IconButton onClick={() => handleDelete(item.id)}>
                              <DeleteIcon sx={{ fontSize: 18, color: 'red' }} />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* Edit Dialog - only used for Service Category now */}
        <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)} fullWidth maxWidth="sm">
          <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="#f0f9ff">
            <DialogTitle sx={{ fontWeight: 600, mx: 'auto', color: '#0b85c8' }}>
              Edit {currentType}
            </DialogTitle>
            <IconButton onClick={() => setEditDialogOpen(false)}>
              <CloseIcon sx={{ color: '#fff', bgcolor: '#0b85c8', borderRadius: 2, p: 0.5, mr: 2 }} />
            </IconButton>
          </Box>
          <DialogContent sx={{ bgcolor: '#f0f9ff' }}>
            <Box sx={{ bgcolor: '#fff', p: 2, borderRadius: 1 }}>
              <TextField
                autoFocus
                fullWidth
                label={`Edit ${currentType}`}
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
              />
              <Box textAlign="center" mt={2}>
                <Button variant="contained" onClick={handleUpdate} sx={{ bgcolor: '#0b85c8' }}>
                  Update
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </Container>
  );
}